<template>
	<div class="page-switcher">
		<div class="container-fluid">
			<transition-group tag="ul" name="slide-in">
				<template v-for="(link, index) in links">
					<li class="page-switcher__links hover-shadow" :style="link.animationOrder" :key="index">
						<router-link class="page-switcher__link" :to="{ name: link.route, params: { flag: link.name } }">
							<SvgIcon class="page-switcher__icon" :iconName=" link.nameIcon"/>
							<span class="page-switcher__name">{{ link.name }}</span>
						</router-link>
					</li>
				</template>
			</transition-group>
		</div>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			showItems: false,
			links: [
				{
					name: 'Property Dashboard',
					nameIcon: 'ico-home',
					route: 'LeadsDashboardAgent',
					animationOrder: '--animation-order: 1;'
				},
				{
					name: 'Customer Dashboard',
					nameIcon: 'ico-user',
					route: 'LeadsDashboardAgent',
					animationOrder: '--animation-order: 2;'
				},
				{
					name: 'Search Customers',
					nameIcon: 'ico-customers',
					route: 'CustomersAgent',
					animationOrder: '--animation-order: 3;'
				},
				{
					name: 'Commercial Properties',
					nameIcon: 'ico-commercial',
					route: 'Commercial',
					animationOrder: '--animation-order: 4;'
				}
			]
		};
	},
	components: {
		SvgIcon
	},
	mounted() {
		// this.$nextTick(() => {
		// 	this.showItems = true;
		// });
	}
};
</script>

<style lang="scss" scoped>
.page-switcher {
    padding-top: 200px;
    padding-bottom: 30px;
    display: flex;
    justify-content: center;

	@include mq(1023px) {
		padding-top: 100px;
	}

	ul {
		display: flex;
		justify-content: center;
		align-items: center;
		@include mq(1023px) {
			flex-wrap: wrap;
		}

		@include mq($sm) {
			flex-direction: column;
		}
	}
}

.page-switcher__name {
	display: flex;
	align-self: end;
}

.page-switcher__links {
	cursor: pointer;
	border: 1px solid $grey-light;
	box-shadow: 0 2px 4px rgba($black, .25);
	border-radius: 8px;
	margin: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	animation-name: animateIn;
	animation-duration: 350ms;
	animation-delay: calc(var(--animation-order) * 100ms);
	animation-fill-mode: both;
	animation-timing-function: ease-in-out;
	box-shadow: 0 0 1px transparent;
	transition: $dur $ease;
	@include mq(1023px) {
		max-width: 45%;
		width: 100%;
	}

	@include mq($sm) {
		max-width: 300px;
		margin: 10px auto;
	}

	&:before {
		pointer-events: none;
		position: absolute;
		z-index: -1;
		content: '';
		top: 100%;
		left: 5%;
		height: 10px;
		width: 90%;
		opacity: 0;
		background: radial-gradient(ellipse at center, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0) 80%);
		transition-duration: 0.3s;
		transition-property: transform opacity;
	}
	@include hover {
		margin-top: -6px;
		&:before {
			opacity: .4;
			transform: translateY(6px);
			animation-name: hover-shadow;
			animation-duration: 1.5s;
			animation-delay: .3s;
			animation-timing-function: linear;
			animation-iteration-count: infinite;
			animation-direction: alternate;
		}
		.page-switcher__link {
			color: $dodger-blue;
		}
	}
}

.page-switcher__link {
    display: flex;
    align-items: center;
    padding: 30px 24px;
    text-decoration: none;
    position: relative;
    text-decoration: none;
    font-family: $font-main;
    font-size: 16px;
    line-height: 1.2;
    color: $shuttle-gray;
    transition: 350ms ease;
    height: 100%;
}

.page-switcher__icon {
	display: block;
	font-size: 21px;
	padding-right: 14px;

	@include mq($xl) {
		padding-right: 12px;
		font-size: 18px;
	}
}

@keyframes animateIn {
  0% {
    opacity: 0;
    transform: scale(0.6);
  }
  
  100% {
    opacity: 1;
  }
}

@keyframes hover-shadow {
	0% {
		transform: translateY(6px);
		opacity: .4;
	}
	50% {
		transform: translateY(3px);
		opacity: 1;
	}
	100% {
		transform: translateY(6px);
		opacity: .4;
	}
}
</style>
